import type { PolymorphicRef } from '@sds-system/types';
import type { ElementType } from 'react';
import { forwardRef } from 'react';
import { StyledRow } from '../Row';
import type { RowComponent, RowProps } from '.';

export const Row: RowComponent = forwardRef(
  <C extends ElementType = 'div'>({ ...props }: RowProps<C>, ref: PolymorphicRef<C>) => {
    return <StyledRow {...props} ref={ref} />;
  },
);
